import ContractsMileageAddRequest, {
  ContractsMileageAddRequestBody,
} from "./contracts-mileage-add.request";

const createBody = (
  request: ContractsMileageAddRequest,
): ContractsMileageAddRequestBody => {
  return {
    companyId: request.companyUuid,
    dietFullAfterHours: request.dietFullAfterHours,
    dietFullRate: request.dietFullRate,
    dietHalfAfterHours: request.dietHalfAfterHours,
    dietHalfRate: request.dietHalfRate,
    disabled: request.disabled,
    distanceRateCarGt900cm3: request.distanceRateCarGt900cm3,
    distanceRateCarLe900cm3: request.distanceRateCarLe900cm3,
    distanceRateCompanyVehicle: request.distanceRateCompanyVehicle,
    distanceRateMoped: request.distanceRateMoped,
    distanceRateMotorcycle: request.distanceRateMotorcycle,
    validSince: request.validSince,
    validTo: request.validTo,
  };
};

const contractsMileageAddRequestFactory = {
  createBody,
};

export default contractsMileageAddRequestFactory;
